import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./components/Home";
import Contact from "./components/Contact";
import "./App.css";

const App = () => {
  const handleAboutClick = () => {
    window.open("https://vaidhyamegha.com/about", "_blank");
  };
  const handleContactClick = () => {
    window.open("https://vaidhyamegha.com/contact", "_blank");
  };

  return (
    <Router>
      <div className="app-wrapper">
        <header className="sticky-header">
          <nav className="nav-container">
            <div className="nav-logo">
              <img src="/logos.png" alt="Agentic Healthcare Logo" className="app-logo" />
            </div>
            <div className="nav-links">
              <Link to="/" className="nav-link">Home</Link>
              <span onClick={handleAboutClick} className="nav-link">About</span>
              <span onClick={handleContactClick} className="nav-link">Contact</span>
            </div>
          </nav>
        </header>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>

        <footer className="app-footer">
          <div className="footer-content">
            <div className="footer-copyright">
              &copy; Copyright 2025 <a href="https://vaidhyamegha.com" target="_blank" rel="noopener noreferrer" className="footer-brand-link">VaidhyaMegha</a> Pvt. Ltd. All Rights Reserved.
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
};

export default App;